import { NewColorScheme } from '../default/Colors';
import { useMemo, useState } from 'react';
import type { VennColors } from '../../style/color';
import { getCurrentTheme } from './getCurrentTheme';
import { transformCustomColorsToVennColors, type CustomColors } from '../../style/customColors';

const GreenColorScheme = (
  process.env.USE_GREEN === 'true' || process.env.NODE_ENV === 'test'
    ? require('../green/Colors').default
    : NewColorScheme
) as VennColors;

export const useColorTheme = () => {
  const baseColors = getCurrentTheme() !== 'default' ? GreenColorScheme : NewColorScheme;

  const [customColors, setCustomColors] = useState<CustomColors | undefined>(undefined);
  const [debugColors, setDebugColors] = useState<VennColors | undefined>(undefined);

  const colors = useMemo(
    () => (customColors ? transformCustomColorsToVennColors(baseColors, customColors) : baseColors),
    [baseColors, customColors],
  );

  return { colors: debugColors ?? colors, customColors, setCustomColors, setDebugColors } as const;
};
